/*
 * LanguageSelect
 * @module components
 * @flow
 */

import React from 'react';
import styled from 'styled-components/macro';
import * as R from 'ramda';
import { palette } from 'styled-theme';

import { Select } from '~/components/Select';
import { LOCALE_DEFAULT, LOCALES } from '~/helpers';

export type LanguageSelectProps = SettingsQuery & {
  onLanguageSelect: () => void,
};

const baseColor = palette('grayscale', 0, true);

const LanguageSelectWrapper = styled(Select)`
  color: ${baseColor};

  .react-select {
    &__value-container,
    &__single-value {
      padding-left: 0;
      padding-right: 0;
      min-width: 20px;
      font-size: 14px;
    }

    &__control {
      &,
      &--is-focused {
        border-color: ${baseColor} !important;
        opacity: 0.8;
      }
    }

    &__indicator {
      color: ${baseColor} !important;
      opacity: 0.8;
    }

    &__option {
      padding-right: 2px;
      padding-left: 2px;
      font-size: 14px;
      text-align: center;
    }
  }
`;

/**
 * LanguageSelect React-component
 * @memberof components
 * @param {Object} props - properties
 * @param {Settings} [props.settings] - app settings
 * @param {Function} [props.onLanguageSelect] - language select handler
 * @example <caption>Simple usage</caption>
 * <LanguageSelect value="en" />
 * @returns {React.Node<*>} React-component
 */
export const LanguageSelect = ({
  settings,
  onLanguageSelect,
}: LanguageSelectProps) => {
  // $FlowIssue
  const locale = R.propOr(LOCALE_DEFAULT, 'locale', settings);
  const value = R.find(R.propEq('value', locale))(LOCALES);

  return (
    <LanguageSelectWrapper
      isSearchable={false}
      options={LOCALES}
      testid="language-select"
      value={value}
      onChange={onLanguageSelect}
    />
  );
};
